import { ISpecificException } from './RequirementsExceptionsService';

export class SpecificReqExcData {
  public B1: ISpecificException[];
  public B2: ISpecificException[];

  constructor(
    { B1, B2 } = {
      B1: [],
      B2: [],
    }
  ) {
    this.B1 = B1;
    this.B2 = B2;
  }
}
